module.exports = __webpack_public_path__ + "static/media/flower.84f98439.svg";